const enDash = '\u2013';

/**
 * Returns the correct 'AM/PM' time suffix given a GTFS time in seconds
 *
 **/
export const getSuffix = (time) => {
  const hours = (time / 3600) % 24;
  return hours >= 12 ? 'PM' : 'AM';
};

/**
 * Takes in a time in seconds representing a GTFS time and converts it to an
 * 'hh:mmAM/PM' string.
 *
 * Ex: 48420 => '1:37PM'
 *
 **/
export const formatTime = (time) => {
  const suffix = getSuffix(time);
  const hours = Math.floor((time / 3600) % 12) === 0 ? 12 : Math.floor((time / 3600) % 12);
  const minutes = Math.floor((time / 60) % 60);
  return `${hours}:${minutes < 10 ? 0 : ''}${minutes}${suffix}`;
};

/**
 * Takes in a service object and formats the start/end time range
 *
 * EX: Output = '9:00PM - 11:00PM (~26 hrs)'
 *           OR '1:15AM - 9:45PM'
 *
 **/
export const getTimes = (service) => {
  let qualifier = '';
  const hourDelta = Math.round((service.end_time - service.start_time) / 3600);
  if (hourDelta > 24) {
    qualifier = ` (~${hourDelta} hrs)`;
  }
  return `${formatTime(service.start_time)}${enDash}${formatTime(service.end_time)}${qualifier}`;
};

/**
 * Takes in a Service object that has the following boolean attributes:
 * - mon, tue, wed, thu, fri, sat, sun
 * The method converts these boolean values to a string that represents
 * the day ranges.
 *
 * Ex: 'Mon. - Thurs., Sat.'
 *
 **/
export const getDays = (service) => {
  const labels = ['Mon.', 'Tues.', 'Wed.', 'Thurs.', 'Fri.', 'Sat.', 'Sun.'];
  const days = [
    service.monday || false,
    service.tuesday || false,
    service.wednesday || false,
    service.thursday || false,
    service.friday || false,
    service.saturday || false,
    service.sunday || false,
  ];
  let count = 0;
  const ranges = [];
  while (days[count] !== undefined) {
    let range = '';
    if (days[count]) {
      const index = count;
      range = `${labels[count]}`;
      count++;
      while (days[count]) {
        count++;
      }
      if (index !== count - 1) {
        range = `${range}${enDash}${labels[count - 1]}`;
      }
      ranges.push(range);
    }
    count++;
  }
  return ranges.join(', ');
};



// WEBPACK FOOTER //
// ./src/ondemand/utils/gtfs.js